import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import { Button, Collapse, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown, NavbarBrand, Navbar, NavItem, NavLink, Nav, Container, UncontrolledTooltip } from "reactstrap";
import { UserContext } from "../../contexts/userContext";

import logo from "../../assets/img/logo-navbar.png";

function ScrollTransparentNavbar() {
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [navbarColor, setNavbarColor] = React.useState((document.documentElement.scrollTop > 499 || document.body.scrollTop) > 499 ? "" : " navbar-transparent");
  const [buyButtonColor, setBuyButtonColor] = React.useState((document.documentElement.scrollTop > 499 || document.body.scrollTop) > 499 ? "info" : "neutral");

  const user = React.useContext(UserContext);

  React.useEffect(() => {
    const updateNavbarColor = () => {
      // if (document.documentElement.scrollTop > 499 || document.body.scrollTop > 499) {
      //   setNavbarColor("");
      //   setBuyButtonColor("info");
      // } else if (document.documentElement.scrollTop < 500 || document.body.scrollTop < 500) {
      setNavbarColor(" navbar-transparent");
      setBuyButtonColor("neutral");
      // }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"my-navbar fixed-top" + navbarColor} color="white" expand="lg">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand to="/" tag={Link} id="navbar-brand">
              {/* Now Ui Kit PRO React */}
              <img className="brand-logo" src={logo} />
            </NavbarBrand>
            {/* <UncontrolledTooltip target="navbar-brand">
              Designed by Invision. Coded by Creative Tim
            </UncontrolledTooltip> */}
            <button
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              className="navbar-toggler"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse isOpen={collapseOpen} navbar>
            <Nav className="ml-auto m-0" id="ceva" navbar>
              {/* <UncontrolledDropdown nav>
                <DropdownToggle caret color="default" data-toggle="dropdown" href="#pablo" id="navbarDropdownMenuLink1" nav onClick={(e) => e.preventDefault()}>
                  <i className="now-ui-icons design_app"></i>
                  <p>Components</p>
                </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink1" right>
                  <DropdownItem to="/" tag={Link}>
                    <i className="now-ui-icons design_image"></i>
                    Presentation
                  </DropdownItem>
                  <DropdownItem to="/index" tag={Link}>
                    <i className="now-ui-icons business_chart-pie-36"></i>
                    All components
                  </DropdownItem>
                  <DropdownItem href="https://demos.creative-tim.com/now-ui-kit-pro-react/#/documentation/introduction?ref=nuk-pro-react-scroll-transparent-navbar" target="_blank">
                    <i className="now-ui-icons design_bullet-list-67"></i>
                    Documentation
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown> */}
              {/* Noticias oculto: feature deshabilitada por ahora (la ruta /noticias sigue existiendo)
              <NavItem>
                <NavLink
                  to="/noticias"
                  tag={Link}
                  onClick={() => {
                    document.documentElement.classList.remove("nav-open");
                    setCollapseOpen(false);
                  }}
                >
                  Noticias
                </NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink
                  to="/torneos"
                  tag={Link}
                  onClick={() => {
                    document.documentElement.classList.remove("nav-open");
                    setCollapseOpen(false);
                  }}
                >
                  Torneos
                </NavLink>
              </NavItem>

              <NavItem>
                {!user && (
                  <Button className="nav-link btn-default" color={buyButtonColor} href="/login">
                    <p>Ingresar</p>
                  </Button>
                )}
                {user && (
                  <Button className="nav-link btn-default" color={buyButtonColor} href="/logout">
                    <p>Desconectar</p>
                  </Button>
                )}
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default ScrollTransparentNavbar;
